import { useFormat } from '@ideavivat/vivat-2';
import { tokenName } from '@/use/useAuth';
import { axios, camelObjectToSnakeObject, filterValueToQuery } from '@/api';
/**
 * It takes a report name, a key, and a name and returns a PDF report
 * @param {string} report - The report to be printed.
 * @param {number | string} key - The key of the report.
 * @param [name] - The name of the file to be downloaded.
 */
function getReport(
  report: string, key: number | string, name = '', variables = {},
) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem(tokenName)}`);

  const file = `${process.env.VUE_APP_BACKEND_HOST}/api/${report}/${key}?${filterValueToQuery(variables)}`;

  fetch(file, {
    headers,
    method: 'GET',
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${name !== '' ? name : `${report}.csv`}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    })
    .catch((reason: any) => console.log(reason));
}

async function getCSVReport(
  report: string, key: number | string, name = '', variables = {},
) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem(tokenName)}`);

  const file = `${process.env.VUE_APP_BACKEND_HOST}/api/${report}/${key}?${filterValueToQuery(variables)}`;

  fetch(file, {
    headers,
    method: 'GET',
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${name !== '' ? name : `${report}`}.csv`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    })
    .catch((reason: any) => console.log(reason));
}

function getPreview(
  report: string, variable: any, name = '', except: string[] = [],
) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${localStorage.getItem(tokenName)}`);
  headers.append('Content-Type', 'application/json');

  const file = `${process.env.VUE_APP_BACKEND_HOST}/api/${report}`;

  fetch(file, {
    headers,
    method: 'POST',
    body: JSON.stringify(camelObjectToSnakeObject(variable, except)),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `[${useFormat.date().computerShortDate()}]-${name !== '' ? name : `${report}`}`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
}

export default function useDownloadReport() {
  return {
    getReport,
    getPreview,
    getCSVReport,
  };
}
